import { render, staticRenderFns } from "./AccommodationParams.vue?vue&type=template&id=0d15bbc6&scoped=true&"
import script from "./AccommodationParams.vue?vue&type=script&lang=js&"
export * from "./AccommodationParams.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationParams.vue?vue&type=style&index=0&id=0d15bbc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15bbc6",
  null
  
)

export default component.exports